<template>
  <v-btn :icon="icon" title="Imprimir Pedido" @click="imprimirPedido()" :rounded="rounded" v-if="online()" >
    <v-icon :left="!icon">mdi-printer-outline</v-icon> <span v-if="!icon">Imprimir Pedido</span></v-btn
  >
</template>

<script>
import { getToken } from "@/global";

export default {
  props: {
    pedido: Object,
    icon: Boolean,
    rounded: Boolean
  },
  methods: {
    imprimirPedido() {      
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/nutricao-animal/pedidos/imprimir-pedido?token=${getToken()}&pedido=${
          this.pedido.id
        }`,
        "_blank"
      );
    },
    online(){
      return navigator.onLine
    }
  },
};
</script>

<style>
</style>